import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';

type PromptLibraryPath =
  '/v1/workspaces/{workspace_id}/prompt-libraries/{prompt_library_id}';

export type DeleteHeySynclyPromptLibraryParams = PathParams<
  PromptLibraryPath,
  'delete'
>;
export type DeleteHeySynclyPromptLibraryResponse = ResponseBody<
  PromptLibraryPath,
  'delete'
>;

export const deleteHeySynclyPromptLibrary = ({
  workspace_id,
  prompt_library_id,
}: DeleteHeySynclyPromptLibraryParams): Promise<DeleteHeySynclyPromptLibraryResponse> =>
  v1ApiClient
    .delete(`/workspaces/${workspace_id}/prompt-libraries/${prompt_library_id}`)
    .then((res) => res.data);
